import socketIo from 'socket.io-client';

let socket: any = null;
let webcamSocket: any = null;
function connectSocket() {
  socket = socketIo(process.env.REACT_APP_SOCKET_URL as string, {
    transports: ['websocket'],
    withCredentials: true
  });
}

function connectWebcamSocket() {
  webcamSocket = socketIo(process.env.REACT_APP_WEBCAM_URL as string, {
    // transports: ["polling", "websocket"],
    transports: ['websocket'],
    withCredentials: true,
    secure: true
  });
}

const chatEvents = {
  CONNECTED_USER_SOCKET_ID: 'CONNECTED_USER_SOCKET_ID',
  CONNECTED_USER_DATA: 'CONNECTED_USER_DATA',
  ONLINE_USER: 'ONLINE_USER',
  GET_ROOMS: 'GET_ROOMS',
  IS_TYPING: 'IS_TYPING',
  CREATE_ROOM: 'CREATE_ROOM',
  UPDATE_ROOM: 'UPDATE_ROOM',
  DELETE_ROOM: 'DELETE_ROOM',
  GET_MESSAGES: 'GET_MESSAGES',
  SEND_MESSAGE: 'SEND_MESSAGE',
  RECEIVE_NEW_ROOM: 'RECEIVE_NEW_ROOM',
  RECEIVE_NEW_MESSAGE: 'RECEIVE_NEW_MESSAGE',
  RECEIVE_UPDATE_MESSAGE: 'RECEIVE_UPDATE_MESSAGE',
  RECEIVE_DELETE_MESSAGE: 'RECEIVE_DELETE_MESSAGE',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  SEND_FILE: 'SEND_FILE',
  READ_MESSAGES: 'READ_MESSAGES',
  RECEIVE_ACTIVE_USERS: 'RECEIVE_ACTIVE_USERS',
  GET_ALL_USERS: 'GET_ALL_USERS',
  READ_ALL_MESSAGES: 'READ_ALL_MESSAGES'
};

const AIChatEvents = {
  AI_CHAT_MESSAGE: 'AI_CHAT_MESSAGE',
  CHAT_BOT_QUESTION_ANSWER: 'CHAT_BOT_QUESTION_ANSWER',
  READ_AI_MESSAGES: 'READ_AI_MESSAGES',
  GET_AI_CHAT_MESSAGES: 'GET_AI_CHAT_MESSAGES',
  READ_ALL_AI_MESSAGES: 'READ_ALL_AI_MESSAGES',
  AI_CHAT_SOCKET_CONNECT: 'AI_CHAT_SOCKET_CONNECT',
  CHAT_WITH_AI: "CHAT_WITH_AI",
  CREATE_AI_ROOM: "CREATE_AI_ROOM",
  GET_ALL_AI_CHAT_ROOMS: "GET_ALL_AI_CHAT_ROOMS",
  AI_FACULTY_PROCTORING_SOCKET_CONNECT:"AI_FACULTY_PROCTORING_SOCKET_CONNECT"
};

export { socket, webcamSocket, chatEvents, AIChatEvents, connectSocket, connectWebcamSocket };
